export default "__VITE_ASSET__BTymdgAu__"